import { IMatchStatisticsDetail } from '@sky-it-livedata/livedata-sports-design-system';
import { isValidLmpMatchStatisticsSubscription } from './typeguards';
import { CreateLmpStatisticsInputSchema } from 'appsync';
import { WidgetError, ErrorName } from '../../../utils/errors';
import { LmpMatchStatisticsSubscription } from '../types';


export default (obj: LmpMatchStatisticsSubscription): IMatchStatisticsDetail => {
  if (isValidLmpMatchStatisticsSubscription(obj)) {
    CreateLmpStatisticsInputSchema().parse(obj.data.onUpdateLmpStatisticsByMatchId, { reportInput: true });
    
    const { createdAt, updatedAt, ...statistics} = obj.data.onUpdateLmpStatisticsByMatchId;

    const payload: IMatchStatisticsDetail = {
      matchStatisticsDetails: statistics as IMatchStatisticsDetail['matchStatisticsDetails']
    }

    return payload;
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in LmpMatchStatisticsSubscription object',
      data: obj,
    });
  }
};
